import React, { Component } from 'react'
import {Grid, Cell} from 'react-mdl';
class skills extends Component {
    render() {
        return (
            <div>
                <Grid>
                    <Cell col={12}>
                        <div style={{fontSize:'20px'}}>
                            <p style={{fontSize:'20px',fontFamily:'Elephant'}}> Programming Language - C,Java,Python</p>
                            <p style={{fontSize:'20px',fontFamily:'Elephant'}}> Frontend Frameworks  - HTML,CSS,ReactJS,AngularJS</p>
                            <p style={{fontSize:'20px',fontFamily:'Elephant'}}> Backend - NodeJS,PHP,.NET</p>
                            <p style={{fontSize:'20px',fontFamily:'Elephant'}}> Databases - MongoDB,MySQL,MSSQL</p>
                            </div>
                    </Cell>
                </Grid>
            </div>
        )
    }
}

export default skills;
